module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/mark_sclose_sp-e8046cca34f5cb5a412e7d4e6dd8898e.png";